import { CSSProperties } from 'styled-components';

export type PaddingProps = {
  padding?: CSSProperties['padding'];
  p?: CSSProperties['padding'];
  paddingTop?: CSSProperties['paddingTop'];
  pt?: CSSProperties['paddingTop'];
  paddingRight?: CSSProperties['paddingRight'];
  pr?: CSSProperties['paddingRight'];
  paddingBottom?: CSSProperties['paddingBottom'];
  pb?: CSSProperties['paddingBottom'];
  paddingLeft?: CSSProperties['paddingLeft'];
  pl?: CSSProperties['paddingLeft'];
  px?: CSSProperties['margin'];
  py?: CSSProperties['margin'];
};

const PADDING_PROPS: ReadonlyArray<keyof PaddingProps> = [
  'padding',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'p',
  'pt',
  'pr',
  'pb',
  'pl',
  'px',
  'py',
];

export const padding = (props: PaddingProps) => ({
  padding: props.padding || props.p,
  paddingTop: props.paddingTop || props.pt,
  paddingRight: props.paddingRight || props.pr,
  paddingBottom: props.paddingBottom || props.pb,
  paddingLeft: props.paddingLeft || props.pl,
  ...(props.px
    ? {
        paddingRight: props.px,
        paddingLeft: props.px,
      }
    : {}),
  ...(props.py
    ? {
        paddingTop: props.py,
        paddingBottom: props.py,
      }
    : {}),
});

const isPaddingProps = (key: any): key is typeof PADDING_PROPS[number] =>
  PADDING_PROPS.includes(key as any);

export const extractPaddingProps = <P extends { [P: string]: any }>(props: P) =>
  Object.keys(props).reduce<PaddingProps>((_props, propName) => {
    if (isPaddingProps(propName)) {
      return {
        ..._props,
        [propName]: props[propName],
      };
    }
    return _props;
  }, {});
